import { useQuery } from "@tanstack/react-query";
import { getPlans } from "src/api/membership";
import { QUERY_KEYS } from "../constants/queryKeys";
export const usePlansQuery = function() {
    let enabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    return useQuery({
        queryKey: [
            ...QUERY_KEYS.PLANS
        ],
        queryFn: getPlans,
        enabled,
        staleTime: 1000 * 60 * 5
    });
};
